var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content","role":"main"}},[_vm._m(0),_c('ApiDokumentation')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"content_title"},[_c('h1',[_vm._v("BIOTECH REST API")])])])])
}]

export { render, staticRenderFns }